import { combineReducers } from 'redux';

import { reducer as example } from './example';

export default combineReducers({ example });
